import { render, staticRenderFns } from "./cmp-camera-popper.vue?vue&type=template&id=08879c2e&scoped=true"
import script from "./cmp-camera-popper.vue?vue&type=script&lang=js"
export * from "./cmp-camera-popper.vue?vue&type=script&lang=js"
import style0 from "./cmp-camera-popper.vue?vue&type=style&index=0&id=08879c2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08879c2e",
  null
  
)

export default component.exports